import type { Editor } from "./canvas";
import type { TLShape } from "@tldraw/tlschema";
import type { Sheet } from "../shared/schema";

/** Direct sheet contents whose rendered bounds cross the paper boundary. */
export function overflowingSheetItems(editor: Editor, sheet: Sheet): TLShape[] {
  const paper = editor.getShapePageBounds(sheet);
  if (!paper) return [];
  return editor
    .getSortedChildIdsForParent(sheet.id)
    .map((id) => editor.getShape(id))
    .filter((shape): shape is TLShape => {
      if (!shape || editor.isShapeHidden(shape)) return false;
      const bounds = editor.getShapePageBounds(shape);
      return !!bounds && !paper.contains(bounds);
    });
}
